export const PHONE_DISPLAY = "+39 340 993 6650";
export const PHONE_TEL = "+393409936650";
export const WA_LINK =
    "https://wa.me/393409936650?text=" +
    encodeURIComponent(
        "Buongiorno, vorrei richiedere un sopralluogo per un'impermeabilizzazione."
    );
export const EMAIL = "loffredo.gennaro@live.it";
export const ZONA = "Napoli e dintorni, e oltre";

export const SERVICES = [
    {
        n: "01",
        icon: "Landmark",
        title: "Impermeabilizzazione terrazzi",
        desc: "Guaine e membrane armate posate a regola d'arte, con risalite sigillate e pendenze verificate. Terrazzi asciutti in ogni stagione.",
    },
    {
        n: "02",
        icon: "Square",
        title: "Impermeabilizzazione lastrici solari",
        desc: "Ripristino e protezione dei lastrici: codi di caduta, scarichi liberi e superfici tenute nel tempo.",
    },
    {
        n: "03",
        icon: "Home",
        title: "Guaina bituminosa",
        desc: "Guaine a metallizzazione stese a fiamma o autocollanti su tetti, coperture e lastrici: il sistema classico che tiene.",
    },
    {
        n: "04",
        icon: "Gem",
        title: "Coperture in resina",
        desc: "Resine continue senza giuntini per lastrici e terrazzi: monolitiche, lavabili, dall'estetica curata.",
    },
    {
        n: "05",
        icon: "Paintbrush",
        title: "Pittura del lastrico",
        desc: "Vernici elastiche riflettenti che proteggono la superficie e alleggeriscono il calore negli ambienti sottostanti.",
    },
    {
        n: "06",
        icon: "Droplets",
        title: "Riparazione infiltrazioni",
        desc: "Cerchiamo il punto esatto della perdita, la sigilliamo e ti consegniamo pareti e soffitti asciutti.",
    },
];

export const WORKS = [
    {
        video: "/videos/lavoro-1.mp4",
        web: "/videos/lavoro-1.webm",
        tag: "Napoli e dintorni",
        title: "Cantiere · 01",
    },
    {
        video: "/videos/lavoro-3.mp4",
        web: "/videos/lavoro-3.webm",
        tag: "Napoli e dintorni",
        title: "Cantiere · 02",
    },
    {
        video: "/videos/lavoro-4.mp4",
        web: "/videos/lavoro-4.webm",
        tag: "Napoli e dintorni",
        title: "Cantiere · 03",
    },
];

export const HERO_IMG =
    "https://images.unsplash.com/photo-1555091097-2da872e5fb7c?q=80&w=1600&auto=format&fit=crop";
export const ABOUT_IMG =
    "https://images.unsplash.com/photo-1652870226267-a25ae73aae7a?q=80&w=1400&auto=format&fit=crop";
export const RAIN_IMG =
    "https://images.unsplash.com/photo-1501691223387-dd0500403074?q=80&w=1600&auto=format&fit=crop";

export const PROCESS = [
    { n: "1", t: "Sopralluogo", d: "Veniamo sul posto, gratuitamente, e ascoltiamo il problema." },
    { n: "2", t: "Diagnosi", d: "Individuiamo la causa reale: non solo il sintomo." },
    { n: "3", t: "Intervento", d: "Cantiere organizzato, materiali giusti, lavori in sicurezza." },
    { n: "4", t: "Collaudo", d: "Verifichiamo insieme la tenuta, prima di lasciare il cantiere." },
];

export const MARQUEE_ITEMS = [
    "Terrazzi",
    "Lastrici solari",
    "Guaina bituminosa",
    "Coperture in resina",
    "Riparazione infiltrazioni",
    "Cantiere pulito",
    "Materiali certificati",
];
